import React, { useCallback } from 'react';
import YesNoModal from '../../../components/YesNoModal';
import { useMutation, gql } from '@apollo/client';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { notification } from 'antd';
import { useHistory } from 'react-router-dom';
import { updatePeopleGroupAction } from '../../../redux-store/people-groups-store';
import { updatePeopleGroupPhotosMutation } from '../constants';

function DeletePeopleGroupPhotoModal({
  peopleGroup,
  photo,
  setPhoto,
  onComplete,
  queryId,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [updatePeopleGroup] = useMutation(updatePeopleGroupPhotosMutation);
  const dispatch = useDispatch();
  const history = useHistory();

  const onYes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await updatePeopleGroup({
        variables: {
          peopleGroup: {
            _id: peopleGroup._id,
            photoIds: peopleGroup.photoIds.filter((i) => i !== photo._id),
            primaryPhotoId:
              peopleGroup.primaryPhotoId === photo._id ? null : undefined,
          },
        },
      });
      if (!response || !response.data || !response.data.updatePeopleGroup) {
        throw new Error('Failed to update people group');
      }

      dispatch(
        updatePeopleGroupAction(
          response.data.updatePeopleGroup.peopleGroup,
          queryId,
        ),
      );

      notification.success({
        message: 'Deleted',
        description: 'Photo deleted successfully',
      });
      setTimeout(() => {
        setPhoto(null);
        if (onComplete) {
          onComplete();
        } else {
          history.goBack();
        }
      }, 1000);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [
    photo,
    peopleGroup,
    updatePeopleGroup,
    setPhoto,
    dispatch,
    history,
    onComplete,
    queryId,
  ]);

  const onNo = useCallback(() => {
    if (!loading) {
      setPhoto(null);
    }
  }, [setPhoto, loading]);

  return (
    <YesNoModal
      title="Delete PeopleGroup"
      question={`Are you sure you want to delete this photo?`}
      yesText="Delete"
      noText="Cancel"
      onYes={onYes}
      onNo={onNo}
      visible={!!photo}
      loading={loading}
      error={error}
    />
  );
}

export default DeletePeopleGroupPhotoModal;
